import { Box } from "@mui/material";
import { FC, useRef, memo } from "react";
import { ErrorMessage } from "./components";
import { ONFIDO_CONTAINER_NAME } from "./constants";
import { useOnfidoHypeFlow } from "./hooks";
import { TOnfidoParams } from "./types";
import { selectIsFirstPhaseStep } from "./selectors";
import { useDispatch, useSelector } from "react-redux";
import { getPrevOnfidoPhase } from "./actions";
import { AppDispatch } from "../../store";

export const Onfido: FC<{ params?: TOnfidoParams }> = memo(({ params }) => {
  const containerRef = useRef<Element>(null);
  const dispatch = useDispatch<AppDispatch>();
  const showArrowBack = useSelector(selectIsFirstPhaseStep);
  const { hasError, isLoading } = useOnfidoHypeFlow({
    params,
    containerRef,
  });
  if (isLoading) return null;
  if (hasError || !params) return <ErrorMessage />;

  return (
    <Box
      ref={containerRef}
      id={ONFIDO_CONTAINER_NAME}
      style={{ position: "relative" }}
    >
      {showArrowBack && (
        <Box
          onClick={() => dispatch(getPrevOnfidoPhase())}
          style={{
            cursor: "pointer",
            position: "absolute",
            top: 38,
            left: 25,
            zIndex: 100,
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="currentColor"
            focusable="false"
            data-castor-icon="true"
          >
            <path d="M21 11H6.414l5.293-5.293-1.414-1.414L2.586 12l7.707 7.707 1.414-1.414L6.414 13H21z"></path>
          </svg>
        </Box>
      )}
    </Box>
  );
});
